module.exports = __webpack_public_path__ + "assets/projects/droplet/opengraph.png";


//////////////////
// WEBPACK FOOTER
// ./assets/projects/droplet/opengraph.png
// module id = 45
// module chunks = 0